// extracted by mini-css-extract-plugin
export default {"thumbnailHolder":"KBEGB0","thumbnail":"SHJyk7","author":"nDeyot","avatar":"x8JFln","username":"tEBfqi","likes":"NjMQog","description":"Q0ZFTd"};